import { ConnectionInfo, SpreadsheetPage, Worksheet } from './excel-sheet.types';
import { Observable } from 'rxjs';

export abstract class UploadExcelFacade {
  abstract launchDialog(): void;
  abstract getExcelConnection(username: string, token: string): Observable<ConnectionInfo>;
  abstract getExcelSpreadsheets(username: string, token: string, searchText?: string): Observable<SpreadsheetPage>;
  abstract getExcelWorksheets(username: string, token: string, spreadsheetId: string): Observable<Worksheet[]>;
  abstract loadMoreSpreadsheets(nextPageUrl: string, currentSpreadsheets: readonly any[]): Observable<SpreadsheetPage>;
}
